/**
 * This enum is supposed to represent the type of HTTP request made by any player,
 * and should be used to categorize the requests in the {@link OnDownloadFinishedEventObject} events.
 *
 * @remarks
 *
 * Instead of creating our own categorization of HTTP request types, we decided to copy the `HttpRequestType` enum
 * from Bitmovin8 Player. This way, we can directly use the `downloadType` value from the `DownloadFinishedEvent`
 * without needing to map it to our own types, and we can ensure that the categorization is consistent with what the
 * player provides. In the case of other players, we can still map their request types to this enum as much as possible
 * and use `UNKNOWN` for any types that don't fit into the existing categories.
 *
 * @see https://github.com/bitmovin-engineering/bitdash/blob/development/src/core/NetworkAPI.ts#L11
 */
export enum HttpRequestType {
  /* eslint-disable perfectionist/sort-enums */

  MANIFEST_DASH = 'manifest/dash',
  MANIFEST_HLS_MASTER = 'manifest/hls/master',
  MANIFEST_HLS_VARIANT = 'manifest/hls/variant',
  MANIFEST_SMOOTH = 'manifest/smooth',
  MANIFEST_ADS = 'manifest/ads',
  MANIFEST_STEERING = 'manifest/steering',

  MEDIA_AUDIO = 'media/audio',
  MEDIA_VIDEO = 'media/video',
  MEDIA_SUBTITLES = 'media/subtitles',
  MEDIA_THUMBNAILS = 'media/thumbnails',
  MEDIA_SEGMENTINDEX = 'media/segmentindex',

  DRM_LICENSE_WIDEVINE = 'drm/license/widevine',
  DRM_LICENSE_PLAYREADY = 'drm/license/playready',
  DRM_LICENSE_FAIRPLAY = 'drm/license/fairplay',
  DRM_LICENSE_PRIMETIME = 'drm/license/primetime',
  DRM_LICENSE_CLEARKEY = 'drm/license/clearkey',
  DRM_LICENSE_TVKEY = 'drm/license/tvkey',

  DRM_CERTIFICATE_FAIRPLAY = 'drm/certificate/fairplay',

  HLS_INTERSTITIALS_ASSET_LIST = 'hls/interstitials/asset-list',

  KEY_HLS_AES = 'key/hls/aes',

  TIME_SYNC = 'time/sync',

  WEBRTC_SDP_REQUEST = 'webrtc/sdp/request',
  WEBRTC_SDP_ANSWER = 'webrtc/sdp/answer',
  WEBRTC_SDP_OFFER = 'webrtc/sdp/offer',

  UNKNOWN = 'unknown',

  INTERNAL = 'internal',

  /* eslint-enable perfectionist/sort-enums */
}
